import { Component } from "react";
import { connect } from "react-redux";

import classnames from "classnames";

import { hideModal } from "../../redux/actions/modalActions";
import { resetCss } from "../../utils/modal";

interface Props {
  modal: ModalInputs;
  hideModal: any;
}

class Modal extends Component<Props, {}> {
  componentDidMount = () => {
    // Add event listeners for keyboard and clicks
    document.addEventListener('keydown', this.handleKeyDown);
    // Use mousedown for better user experience (fires before click)
    document.addEventListener('mousedown', this.handleClickOutside, true);
  };

  componentWillUnmount = () => {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mousedown', this.handleClickOutside, true);
  };

  componentDidUpdate = (prevProps: Props) => {
    if (this.props.modal.status !== prevProps.modal.status) {
      if (this.props.modal.status === "hidden") {
        // fix the body to stop scrolling
        document.body.className = " ";
      } else {
        // unfix the body
        if (this.props.modal?.isFixed) {
          document.body.className +=
            "  u-overflow--scroll-x--hidden u-overflow--scroll--hidden u-overflow--scroll-y u-fixed u-vw";
        }
      }
    }
  };

  // Handle Escape key press
  handleKeyDown = (e: KeyboardEvent) => {
    const { status, preventClose } = this.props.modal;
    if (e.key === 'Escape' && status !== 'hidden' && !preventClose) {
      this.closeModalMethods();
    }
  };

  // Handle clicks outside the modal content
  handleClickOutside = (e: MouseEvent) => {
    const { status, preventClose } = this.props.modal;
    
    if (status === 'hidden' || preventClose) return;
    
    // We're using a simpler approach now with the overlay div
    // The overlay's onClick handler will take care of closing the modal
  };

  closeModalMethods = async () => {
    if (this.props.modal.onClose) {
      await this.props.modal.onClose();
    }
    await this.props.hideModal();

    resetCss();
  };

  render() {
    const { status, component, data, className, style, isSearchSuggestion, preventClose } = this.props.modal;
    const modalIsHidden = status === "hidden";
    return (
      <div
        className={classnames("o-modal ", {
          "u-opacity--0 u-vis--hidden": modalIsHidden,
          [className]: className, // Only add if className exists
        })}
        style={style}
      >
        {/* For search suggestions, we'll use a different approach */}
        {isSearchSuggestion && (
          <>
            {/* This is a full-screen transparent overlay that sits behind the content */}
            <div 
              className="o-modal__search-overlay"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'transparent',
              }}
              onClick={preventClose ? undefined : this.closeModalMethods}
            />
          </>
        )}
        
        {/* Regular background overlay for non-search suggestion modals */}
        {!isSearchSuggestion && (
          <div
            className="o-modal__background"
            onClick={preventClose ? undefined : this.closeModalMethods}
          />
        )}
        {component && component(data)}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  modal: state.modal,
});

export default connect(mapStateToProps, { hideModal })(Modal);
